export default __webpack_public_path__ + "static/media/404.65b23230.jpg";